function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-arrow_left"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "arrow_left",
  clipPath: "url(#clip-arrow_left)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-forward-outline",
  transform: "translate(17 17) rotate(180)",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M4.167,10.833H14.05l-3.025,3.633a.834.834,0,1,0,1.283,1.067l4.167-5a.987.987,0,0,0,.075-.125c0-.042.042-.067.058-.108a.8.8,0,0,0,0-.6c0-.042-.042-.067-.058-.108a1,1,0,0,0-.075-.125l-4.167-5a.834.834,0,1,0-1.283,1.067L14.05,9.167H4.167a.833.833,0,1,0,0,1.667Z",
  fill: "currentColor"
})));

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_left.9bf93e26.svg";
export { ForwardRef as ReactComponent };